import { useCallback, useEffect, useState } from 'react';
import { getCryptoLoan } from '../../services/crypto.api';

export function useCryptoLoan(options?: { autoFetch?: boolean }) {
  const { autoFetch = true } = options || {};
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const resp = await getCryptoLoan();
      setData(resp || null);
      return resp || null;
    } catch (err: any) {
      setError(err?.message || 'Failed to fetch crypto loan');
      setData(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!autoFetch) return;
    let mounted = true;
    (async () => {
      if (!mounted) return;
      await fetchData();
    })();
    return () => { mounted = false };
  }, [fetchData, autoFetch]);

  return { data, loading, error, refetch: fetchData };
}

export default useCryptoLoan;
